import { usePopupStore } from 'src/store/popupStore';
import {IoIosClose} from "react-icons/io";

export default function Popup() {
    const { isOpen, icon, title, content, onConfirm, closePopup } = usePopupStore();

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-sm">
                <div className="p-3">
                    <div className="flex items-start justify-between">
                        <div className="pl-3 pt-3">
                            <div className="w-12 h-12 rounded-full flex items-center justify-center bg-red-200/20 text-2xl text-red-500">{icon}</div>
                        </div>
                        <button onClick={closePopup} className="text-xl"><IoIosClose /></button>
                    </div>
                    <div className="px-3">
                        <h2 className="text-md font-semibold py-3">{title}</h2>
                        <div className="text-xs font-normal text-[#646971]">{content}</div>
                    </div>
                </div>
                <div className="flex justify-end gap-2 border-t p-3">
                    <button onClick={closePopup} className="text-gray-500 border rounded-md px-4 h-9">Cancel</button>
                    {onConfirm && (
                        <button
                            onClick={() => {
                                const confirmHandler = onConfirm;
                                closePopup();
                                confirmHandler?.();
                            }}
                            className="bg-red-500 text-white px-4 h-9 rounded-md"
                        >
                            Delete
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}